export { default } from './like-button-with-count';
